import { LingodaLogo } from '@lingoda/logotype';
import { Button, Grid, Hidden, Toolbar, Typography } from '@lingoda/ui';
import { trans } from '@lingoda/i18n';
import {
    RouterLink,
    defaultAppPath,
    directRegisterSectionPath,
    getStartedFlowPath,
    loginPath,
    m2mRegisterSectionPath,
    marketingWebPath,
    optionalArg,
    registerSectionSprintPath,
    teamsRegisterSectionPath,
    useRouteMatch,
    useRouteMatcher,
} from '@lingoda/router';
import { useResolution } from '@lingoda/ui/hooks';
import { colorsPalette } from '@lingoda/ui/theme';
import { useHeaderContext } from '@lingoda/contexts';

interface Props {
    disabledLogo?: boolean;
}

export const UnknownUserHeader = ({ disabledLogo }: Props) => {
    const isLogin = useRouteMatcher([loginPath(), defaultAppPath()]);
    const isSectionRegister = !!useRouteMatch(REGISTRATION_ROUTES);
    const isPhablet = useResolution('phablet');
    const { sticky: headerSticky } = useHeaderContext();

    const isWhite = isSectionRegister && !isPhablet && !headerSticky;

    return (
        <Toolbar data-testid="unknown-header">
            {disabledLogo ? (
                <LingodaLogo white={isWhite} width={100} />
            ) : (
                <RouterLink to={marketingWebPath()}>
                    <LingodaLogo white={isWhite} width={100} />
                </RouterLink>
            )}
            <Hidden smDown>
                {isLogin && <RegisterAction />}
                {isSectionRegister && <LoginAction />}
            </Hidden>
        </Toolbar>
    );
};

const REGISTRATION_ROUTES = [
    optionalArg(m2mRegisterSectionPath.raw, 'curriculum'),
    teamsRegisterSectionPath.raw,
    optionalArg(directRegisterSectionPath.raw, 'curriculum'),
    optionalArg(registerSectionSprintPath.raw, 'curriculum'),
];

const LoginAction = () => (
    <Grid container justify="flex-end" spacing={2} alignItems="center">
        <Grid item>
            <Typography align="center" htmlColor={colorsPalette.blackAlpha[70]}>
                {trans('already-have-an-account', {}, 'public-common')}
            </Typography>
        </Grid>
        <Grid item>
            <Button color="primary" variant="contained" size="small" href={loginPath()}>
                {trans('form-login-button', {}, 'public-common')}
            </Button>
        </Grid>
    </Grid>
);

const RegisterAction = () => {
    return (
        <Grid container justify="flex-end" spacing={2} alignItems="center">
            <Grid item>
                <Typography align="center" htmlColor={colorsPalette.blackAlpha[70]}>
                    {trans('dont-have-an-account-yet', {}, 'public-common')}
                </Typography>
            </Grid>
            <Grid item>
                <Button
                    color="primary"
                    variant="contained"
                    size="small"
                    href={getStartedFlowPath()}
                >
                    {trans('sign-up', {}, 'public-common')}
                </Button>
            </Grid>
        </Grid>
    );
};
